import type { AccessPair } from '@/shared/lib'

/** `/v1/settlements` — своего права нет: клиенту `403`, менеджеру нужен `client` и `manager.debts.view`. */
export const SETTLEMENTS_ACCESS: AccessPair = { onBehalf: 'manager.debts.view' }
